module.exports = __webpack_public_path__ + "static/img/mTax-05.db666e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mimage/mTax-05.png
// module id = w8c3
// module chunks = 1